import { TerrainEngine, WorldPoint2 } from '@strava/mre';

export const calculateScrubberTranslatePixelValues = (
  terrainEngine: TerrainEngine,
  container: HTMLElement,
  worldPosition: WorldPoint2
) => {
  const containerPositionFractions = terrainEngine
    .getCamera()
    .getScreenPosition(worldPosition);

  if (!containerPositionFractions || containerPositionFractions.isOccluded) {
    return null;
  }

  return {
    x:
      container.clientLeft +
      container.clientWidth * containerPositionFractions.x,
    y:
      container.clientTop +
      container.clientHeight * containerPositionFractions.y
  };
};
